import { useGraphQLQuery } from '@betterment/js-runtime';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import FourOhOneKContributionsOverviewCard from '../../../FourOhOneKContributionsOverviewCard';
import { LegalAccountTaxationType } from '../../../graphql/schema';
import { EnvelopeAccountSubAccountTypesDocument } from '../../graphql/envelopeAccountSubAccountTypes.generated';

export const FourOhOneKContributionsCard: React.FC = () => {
  const accountId = useRequiredParam('accountId');
  const { data } = useGraphQLQuery(EnvelopeAccountSubAccountTypesDocument, { variables: { accountId } });

  if (!data) return <CardLoader />;
  if (data.account.__typename !== 'ManagedAccount') return null;

  const four01kTypes = new Set([LegalAccountTaxationType.Roth_401K, LegalAccountTaxationType.Traditional_401K]);

  if (!data.account.subAccounts.map(a => a.legalAccount.taxationType).some(t => four01kTypes.has(t))) return null;

  return (
    <ErrorBoundary fallbackType="none">
      <FourOhOneKContributionsOverviewCard />
    </ErrorBoundary>
  );
};
